import { useEffect, useRef, useState } from 'react';

interface GalleryGridProps {
  onImageClick: (image: string) => void;
}

const galleryImages = [
  {
    id: 1,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/8fe0e580f0cebce5b311a4cb750140be.jpeg',
    title: ''
  },
  {
    id: 2,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/e7070847d1912d24598fc80955781d2d.jpeg',
    title: ''
  },
  {
    id: 3,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/52f2f6cbc7254e6f5b6120525f5d705a.jpeg',
    title: ''
  },
  {
    id: 4,
    src: 'https://public.readdy.ai/ai/img_res/dea302fe36713f3604e53f08ec723d2d.jpg',
    title: ''
  },
  {
    id: 5,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/ae1e809c4e20d22cb33364879c5758a3.jpeg',
    title: ''
  },
  {
    id: 6,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/22dc1d7a317cfc900f8a0b7b4fbacbc4.jpeg',
    title: ''
  },
  {
    id: 7,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/a8cf4a710f97660e23a8826e1430e8cb.jpeg',
    title: ''
  },
  {
    id: 8,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/71fd80fce129f8cceda4a871e9b4ab3c.jpeg',
    title: ''
  },
  {
    id: 9,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/54edefe89563b732127ef495c999f969.jpeg',
    title: ''
  },
  {
    id: 10,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/c041222b67e69a2cac4c9c210a3bf953.jpeg',
    title: ''
  },
  {
    id: 11,
    src: 'https://readdy.ai/api/search-image?query=Aluminum%20awning%20window%20tilting%20open%20modern%20house%20ventilation%20professional%20photography%20bright%20interior&width=600&height=500&seq=gal11&orientation=portrait',
    title: ''
  },
  {
    id: 12,
    src: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/846a9b29ddc0d6db32ffd0bb8d4de152.jpeg',
    title: ''
  }
];

export default function GalleryGrid({ onImageClick }: GalleryGridProps) {
  const [visibleItems, setVisibleItems] = useState<Set<number>>(new Set());
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = Number(entry.target.getAttribute('data-id'));
            setVisibleItems((prev) => new Set([...prev, id]));
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = gridRef.current?.querySelectorAll('[data-id]');
    items?.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        {/* Título da Seção */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            Nossos Projetos
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Confira alguns dos nossos trabalhos realizados em alumínio e vidro
          </p>
        </div>

        {/* Grid de Fotos */}
        <div
          ref={gridRef}
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
        >
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              data-id={image.id}
              onClick={() => onImageClick(image.src)}
              className={`group relative aspect-[4/5] rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-700 cursor-pointer transform hover:-translate-y-1 ${
                visibleItems.has(image.id)
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              {/* Imagem */}
              <img
                src={image.src}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Ícone de Zoom */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <i className="ri-zoom-in-line text-white text-2xl"></i>
                </div>
              </div>

              {/* Título */}
              <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-white font-medium text-sm text-center">
                  {image.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
